module.exports = __webpack_public_path__ + "static/media/p1_img3.ed4ce4f8.svg";